import React from "react";

export default function SamplePrevArrow({ className, style, onClick }) {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#00000080",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        left: "10px",
        zIndex: 10,
      }}
      onClick={onClick}
    >
      <i
        className="fa fa-chevron-left"
        style={{ color: "#fff", fontSize: "20px" }}
      ></i>
    </div>
  );
}
